import * as React from "react";
import { useZerofyNotificationBadges } from "@xingternal/crate-communication-use-zerofy-notification-badges";
const Zerofier = ({
  activeItem,
  loadingAppStatsQuery,
  changeNotification,
  notificationKeysMap
}) => {
  const { markBadgesAsSeen } = useZerofyNotificationBadges();
  const currentNotificationBadge = activeItem && notificationKeysMap[activeItem];
  React.useEffect(() => {
    if (!loadingAppStatsQuery && currentNotificationBadge !== void 0) {
      changeNotification(currentNotificationBadge, 0);
      markBadgesAsSeen([currentNotificationBadge]);
    }
  }, [
    changeNotification,
    loadingAppStatsQuery,
    markBadgesAsSeen,
    currentNotificationBadge
  ]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
};
export {
  Zerofier
};
